import {IonicModule} from '@ionic/angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ActionPointPage} from './action-point.page';
import {HeaderModule} from '../../components/header/header.module';
import {ActionPointPageRoutingModule} from './action-point-routing.module';
import {ActionPointListModule} from '../../components/action-point-list/action-point-list.module';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {SwiperModule} from 'swiper/angular';
import {PanelHeaderComponent} from "../../components/panel-header/panel-header.component";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ActionPointPageRoutingModule,
        ActionPointListModule,
        HeaderModule,
        TranslatePipe,
        TranslateDirective,
        SwiperModule,
        PanelHeaderComponent
    ],
  exports: [
    ActionPointPage
  ],
  declarations: [ActionPointPage]
})
export class ActionPointPageModule {
}
